import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import QIllustration from 'components/QIllustration';

const Maintenance = () => (
  <Box
    id='maintenance'
    display='flex'
    flexDirection='column'
    width='100vw'
    height='100vh'
    justifyContent='center'
    alignItems='center'
    position='absolute'
  >
    <QIllustration name='planeCrash' alt='maintenance' style={{ width: '50%', height: '50%', objectFit: 'contain' }} />
    <Typography variant='displayMedium'>{"We're down for maintenance."}</Typography>
    <Typography variant='displayMedium'>{"We'll be back up shortly."}</Typography>
  </Box>
);
export default Maintenance;
